import React from 'react';

import Button from 'components/atoms/Button';
import Heading from 'components/atoms/Heading';
import Link from 'components/atoms/Link';
import Text from 'components/atoms/Text';
import CustomModal from 'components/organisms/Modal';

interface SsoModalProps {
  isOpen: boolean;
  content?: string;
  handleClose?: () => void;
  title?: string;
  hrefLoginSSO?: () => void;
  cancelText?: string;
  confirmText?: string;
  isHideCancel?: boolean;
  linkRedirect?: string;
}

const SsoModal: React.FC<SsoModalProps> = ({
  isOpen,
  content,
  handleClose,
  title,
  hrefLoginSSO,
  cancelText,
  confirmText,
  isHideCancel,
  linkRedirect,
}) => (
  <CustomModal
    isOpen={isOpen}
    className="ssoModal"
    iconName="closeWhite"
  >
    <div className="t-ssoModal">
      <div className="t-ssoModal_title">
        <Heading
          type="h5"
          content={title}
          modifiers={['center', 'letterSpacing', '700', 'primaryReverseLinear']}
        />
      </div>
      <div className="t-ssoModal_content">
        <Text modifiers={['400', 'md', 'davysGrey', 'center']}>{content}</Text>
      </div>
      {linkRedirect ? (
        <div className="t-ssoModal_link">
          <Link href={linkRedirect} useExternal>
            <Text
              modifiers={['center', 'letterSpacing', '700', 'primaryReverseLinear']}
            >
              {confirmText}
            </Text>
          </Link>
        </div>
      ) : (
        <div className="t-ssoModal_buttons">
          {cancelText && !isHideCancel && (
            <div className="t-ssoModal_buttons-item" onClick={handleClose}>
              <Button modifiers={['pd-x-10', 'outline', '700']}>{cancelText}</Button>
            </div>
          )}
          <div className="t-ssoModal_buttons-item" onClick={hrefLoginSSO}>
            <Button modifiers={['pd-x-10', 'primaryLinearReverse', 'white', '700']}>{confirmText}</Button>
          </div>
        </div>
      )}
    </div>
  </CustomModal>
);

SsoModal.defaultProps = {
  handleClose: undefined,
  title: '',
  content: undefined,
  hrefLoginSSO: undefined,
  confirmText: 'Đăng nhập',
  cancelText: 'Huỷ bỏ',
  isHideCancel: false,
  linkRedirect: undefined,
};

export default SsoModal;
